export default function IdlePopUp() {
  return <></>;
}
